import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { NavigationProvider } from './contexts/NavigationContext';
import AnimatedRoutes from './components/AnimatedRoutes';
import './App.css';

function App() {
  return (
    <NavigationProvider>
      <Router>
        <div className="App">
          <AnimatedRoutes />
        </div>
      </Router>
    </NavigationProvider>
  );
}

export default App;
